export default __webpack_public_path__ + "static/media/m.a0a01a7e.mp3";